import Dream from 'actions/dream';

export default Dream.createReducer();
